import { useIntl } from 'react-intl';

import { WARNING_ICON } from 'consts';
import { useToastMessageContext } from 'context/toast/toast';
import { getWarningIcon } from 'utils';

import { useAppStore } from '../../../common/useAppStore';

export function useHandleToastError() {
  const intl = useIntl();
  const { appStore } = useAppStore();
  const toastMessageContext = useToastMessageContext();
  const warningIcon = `${appStore.staticAssetsUrl}${getWarningIcon(WARNING_ICON)}`;

  return () => {
    toastMessageContext.showToast({
      title: intl.formatMessage({
        id: `AppErrorReaction.mediumError`,
        defaultMessage: 'Sorry, this action cannot be completed.',
      }),
      icon: warningIcon,
      onClear: () => appStore.clearAllApiError(),
    });
  };
}
